"use client";

import * as React from "react";
import { useState, useMemo } from "react";
import { ShadLineChart } from "../ShadChart";
import { buildOccupancySeries } from "./nplOccupancyFromHourly";

const chartConfig = {
    occupancy: { label: "תפוסה", color: "#60A3D9" },
    entering: { label: "נכנסים", color: "hsl(var(--chart-2))" },
    leaving: { label: "יוצאים", color: "hsl(var(--chart-1))" },
};

const locationHebrewName = {
    "AHAD_HA'AM": "אחד העם",
    "SAN_MARTIN": "סן מרטין",
    "ZVI": "שדרות צבי",
    "BERNSTEIN": "פרץ ברנשטיין",
    "CENTER_OF_THE_PARK": "חניוני לב הפארק",
    "SHAKH": "שחר",
    "CHEN": "חן",
};

export const NationalParkShadLineChart = React.memo(function Component({
    data,
    deviceNames,
    lineDeviceName,
    setLineDeviceName,
}) {
    const [timeRange, setTimeRange] = useState("24h");

    const filteredData = useMemo(() => {
        if (!data || data.length === 0) return [];
        // Cumulate on the full series first so the latest point matches strip/map.
        const withOccupancy = buildOccupancySeries(data, lineDeviceName);
        const referenceDate = new Date(withOccupancy[withOccupancy.length - 1].date);

        const daysToSubtract = {
            "8h": 8,
            "24h": 24,
            "48h": 48,
            "3d": 72,
            "1w": 168,
        }[timeRange] || 168;

        const startDate = new Date(referenceDate);
        startDate.setHours(referenceDate.getHours() - daysToSubtract);

        return withOccupancy.filter((item) => new Date(item.date) >= startDate);
    }, [timeRange, data, lineDeviceName]);

    const filterDayOptions = [
        {
            value: "8h",
            filterDayOptionComponent: (
                <>
                    <div>שעות אחרונות</div>
                    <div>8</div>
                </>
            ),
        },
        {
            value: "24h",
            filterDayOptionComponent: (
                <>
                    <div>שעות אחרונות</div>
                    <div>24</div>
                </>
            ),
        },
        {
            value: "48h",
            filterDayOptionComponent: (
                <>
                    <div>שעות אחרונות</div>
                    <div>48</div>
                </>
            ),
        },
        {
            value: "3d",
            filterDayOptionComponent: (
                <>
                    <div>ימים אחרונים</div>
                    <div>3</div>
                </>
            ),
        },
        {
            value: "1w",
            filterDayOptionComponent: (
                <>
                    <div>שבוע חולף</div>
                </>
            ),
        },
    ];

    const cardDescription = `כניסות, יציאות ותפוסה מצטברת ב ${timeRange.slice(0, -1)} ${
        timeRange.substring(timeRange.length - 1) === "h"
            ? "שעות"
            : timeRange.substring(timeRange.length - 1) === "d"
              ? "ימים"
              : "שבוע"
    } האחרונות`;

    return (
        <ShadLineChart
            timeRange={timeRange}
            setTimeRange={setTimeRange}
            filterDayOptions={filterDayOptions}
            lineDeviceName={lineDeviceName}
            setLineDeviceName={setLineDeviceName}
            deviceNames={deviceNames}
            locationHebrewName={locationHebrewName}
            chartConfig={chartConfig}
            filteredData={filteredData}
            cardDescription={cardDescription}
        />
    );
});
